import { Grid } from "@mui/material";
import { useAsignaturas } from "../../../context/SuperAdmin/OASContexts/AsignaturasContext";
import { Spinner } from "../../../components/Loading/Spinner";
import HeaderAsignaturas from "../../../components/Table/OAS/Asignaturas/HeaderAsignaturas";
import AsignaturasTable from "../../../components/Table/OAS/Asignaturas/AsignaturasTable";
import DeleteAsignaturasModal from "../../../components/Table/OAS/Asignaturas/DeleteAsignaturasModal";
import CreateAsignaturaModal from "../../../components/Table/OAS/Asignaturas/CreateAsignaturaModal";
import EditAsignaturaModal from "../../../components/Table/OAS/Asignaturas/EditAsignaturaModal";

const AsignaturasPage = () => {
  const { isLoading } = useAsignaturas();

  if (isLoading) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Agregar o eliminar asignaturas */}
      <Grid item>
        <HeaderAsignaturas />
      </Grid>

      {/* Tabla de asignaturas */}
      <Grid item>
        <AsignaturasTable />
      </Grid>

      {/* Modal para confirmar eliminar asignaturas de la organización */}
      <Grid item>
        <DeleteAsignaturasModal />
      </Grid>

      {/* Modal para crear una asignatura en una organización */}
      <Grid item>
        <CreateAsignaturaModal />
      </Grid>

      {/* Modal para editar una asignatura en una organización */}
      <Grid item>
        <EditAsignaturaModal />
      </Grid>
    </Grid>
  );
};

export default AsignaturasPage;
